import { FilterState } from '../../../../common/components/TableToolbar/FilterPopover';

export const formatDate = (date) => {
    if (!(date instanceof Date)) {
        return '--';
    }
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = getMonthName(date.getMonth()).substring(0, 3);
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
};

export const formattedDate = (timePeriod) => {
    const currentDate = new Date();
    let label = '';

    switch (timePeriod) {
        case 'This Week': {
            const startOfWeek = new Date(currentDate);
            startOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + 1);
            const endOfWeek = new Date(currentDate);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            label = `${formatDate(startOfWeek)} to ${formatDate(endOfWeek)}`;
            break;
        }
        case 'This Month': {
            const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
            label = `${formatDate(startOfMonth)} to ${formatDate(endOfMonth)}`;
            break;
        }
        case 'This Year': {
            const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
            const endOfYear = new Date(currentDate.getFullYear(), 11, 31);
            label = `${formatDate(startOfYear)} to ${formatDate(endOfYear)}`;
            break;
        }
        case 'Past 7 Days': {
            const past7DaysStart = new Date(currentDate);
            past7DaysStart.setDate(currentDate.getDate() - 6);
            label = `${formatDate(past7DaysStart)} to ${formatDate(currentDate)}`;
            break;
        }
        case 'Past 30 Days': {
            const past30DaysStart = new Date(currentDate);
            past30DaysStart.setDate(currentDate.getDate() - 29);
            label = `${formatDate(past30DaysStart)} to ${formatDate(currentDate)}`;
            break;
        }
        case 'Past Year': {
            const pastYearStart = new Date(currentDate);
            pastYearStart.setDate(currentDate.getDate() - 364);
            label = `${formatDate(pastYearStart)} to ${formatDate(currentDate)}`;
            break;
        }
        case 'Next 7 Days': {
            const next7DaysStart = new Date(currentDate);
            next7DaysStart.setDate(currentDate.getDate() + 1);
            const next7DaysEnd = new Date(currentDate);
            next7DaysEnd.setDate(next7DaysStart.getDate() + 6);
            label = `${formatDate(next7DaysStart)} to ${formatDate(next7DaysEnd)}`;
            break;
        }
        case 'Next 30 Days': {
            const next30DaysStart = new Date(currentDate);
            next30DaysStart.setDate(currentDate.getDate() + 1);
            const next30DaysEnd = new Date(currentDate);
            next30DaysEnd.setDate(next30DaysStart.getDate() + 29);
            label = `${formatDate(next30DaysStart)} to ${formatDate(next30DaysEnd)}`;
            break;
        }
        default:
            label = '';
            break;
    }

    return label;
};

const getMonthName = (monthIndex) => {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[monthIndex];
};

export const hardCodedColumnsGenerator = (binderCustomColumns) => {
    return [
        {
            title: 'Study Stage',
            field: 'study_stage',
            key: 'study_stage',
            hidden: true,
            toolbarFilter: FilterState.MULTILIST,
            toolbarFilterData: [
                { label: 'Study Start-Up', key: 'Study Start-Up' },
                { label: 'Pending Approval', key: 'Pending Approval' },
                { label: 'Open to Accrual', key: 'Open to Accrual' },
                { label: 'Maintenance', key: 'Maintenance' },
                { label: 'Archived', key: 'Archived' },
                { label: 'Closed', key: 'Closed' }
            ],
        },
        {
            title: 'Status',
            field: 'status',
            key: 'status',
            hidden: true,
            toolbarFilter: FilterState.MULTILIST,
            toolbarFilterData: [
                { label: 'Active', key: 'Active' },
                { label: 'Archived', key: 'Archived' },
                { label: 'Draft', key: 'Draft' }
            ],
        },
        {
            title: 'Activation Date',
            field: 'activationDate',
            key: 'activation_date',
            hidden: true,
            toolbarFilter: FilterState.DATEFILTER,
            toolbarFilterData: [
                { label: formattedDate('This Week'), key: formattedDate('This Week') },
                { label: formattedDate('This Month'), key: formattedDate('This Month') },
                { label: formattedDate('This Year'), key: formattedDate('This Year') },
                { label: formattedDate('Past 7 Days'), key: formattedDate('Past 7 Days') },
                { label: formattedDate('Past 30 Days'), key: formattedDate('Past 30 Days') },
                { label: formattedDate('Past Year'), key: formattedDate('Past Year') }
            ],
        },
        {
            title: binderCustomColumns && binderCustomColumns.find(column => column.key === 'renewal_date').label || 'IRB / IEC Renewal Date',
            field: 'renewalDate',
            key: 'renewal_date',
            hidden: true,
            toolbarFilter: FilterState.DATEFILTER,
            toolbarFilterData: [
                { label: formattedDate('This Week'), key: formattedDate('This Week') },
                { label: formattedDate('This Month'), key: formattedDate('This Month') },
                { label: formattedDate('This Year'), key: formattedDate('This Year') },
                { label: formattedDate('Next 7 Days'), key: formattedDate('Next 7 Days') },
                { label: formattedDate('Next 30 Days'), key: formattedDate('Next 30 Days') },
            ],
        },
    ];
};